import { FlexRow, FormCell, Header2Text, NavigationItem } from 'ui-toolkit/components';
import React from 'react';
import { IUnderwriterProfileSummaryData } from '../../../types/administration/pricing/IUnderWriterProfileSummary';
import { StateAbbreviationToLongName } from '../../../ui-toolkit/enums/states';

export const HeaderForUnderwriterProfileDetailPage: React.FC<IUnderwriterProfileSummaryData> = ({
  underwriter,
  state,
  zone,
}) => (
  <FlexRow justifyContent={'space-between'} width={100}>
    <FormCell hintText={'Details for this Underwriter'}>
      <Header2Text>{`${underwriter || ''} ${StateAbbreviationToLongName[state]} ${zone || ''}`}</Header2Text>
    </FormCell>
    <NavigationItem
      to={'/spa/admin/administration/pricing'}
      intent={'primary'}
      appearance={'primary'}
      text={'Return to Menu'}
    />
  </FlexRow>
);
